import { useMemo } from 'react';

function decodeJwt(token) {
  try {
    const payload = token.split('.')[1];
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function usePortalSession() {
  return useMemo(() => {
    const token = localStorage.getItem('portal_token') || localStorage.getItem('cloudtrail_token');
    if (!token) {
      return { token: null, claims: null, services: [], hasService: () => false };
    }
    const claims = decodeJwt(token) || {};
    const services = Array.isArray(claims.services) ? claims.services : [];
    return {
      token,
      claims,
      services,
      hasService: (name) => services.includes(name),
    };
  }, []);
}
